module.exports = __webpack_public_path__ + "f8747c4cdf4f02bca313300b27e1dcb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/apple_2022_chart.png
// module id = 1631
// module chunks = 0